<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="affiliations.length !== 0">

        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="col-xs-6 text-center">
              Best Organisations: <span class="font-extra-bold m-t-xl m-b-xs text-info" >{{bestExperts}}</span>
            </div>
            <div class="col-xs-6 text-center">
              Total Organisations estimate: <span class="font-extra-bold m-t-xl m-b-xs" style="">{{nbEstimateAffiliation}}</span>
            </div>
          </div>

        </div>

        <div class="panel-body no-padding ">
          <table style="width: 100%">
            <tr style="height: 25px">
              <th class="col-md-5 col-xs-5"><span>Title</span></th>
              <th class="col-md-4 col-xs-4">
                <div class="row">
                  <div class="col-xs-5 col-md-5 text-center">
                    <div class="row">
                      <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                    </div>
                  </div>
                  <div class="col-xs-7 col-md-7">
                    <div class="row">
                      <span role="button" @click="changeSort('affiliation')">Affiliation <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                    </div>
                  </div>
                </div>

              </th>
              <th class="col-md-1 col-xs-1 text-center">
                <span role="button" @click="changeSort('nbDocuments')">Nb Docs<i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>
              <th class="col-md-1 col-xs-1 text-center">
                <span role="button" @click="changeSort('pubDate')">Date<i style="padding-left: 15px" class="fa fa-sort"></i></span>
              </th>
              <th class="col-md-1 col-xs-1 text-center"><span>Action</span></th>
            </tr>

          </table>
          <div v-if="affiliations.length !== 0" >
            <div v-for="(affiliation, key) in affiliations" v-if="affiliation && key < context.nbItemsDisplay" :key="key + '-' + affiliation.organisationID" class="clearfix ">
              <affiliation-top v-model="affiliations[key]" :context="context" :key="key + '-' + affiliation.organisationID"/>
              <div class="col-xs-12 collapse" :id="'collapse-'+ affiliation.organisationID" style="padding: 20px" >
                <document-patent v-model="affiliations[key].docs" :pubDateSelected="context.pubDateSelected" :context="context"/>
              </div>
            </div>

            <div class="text-center" style="padding: 25px" v-if="affiliations.length > context.nbItemsDisplay">
              <button class="btn btn-primary btn-xs" :class="affiliations.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="affiliations.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import AffiliationTop from '../documents/AffiliationTop'
import DocumentPatent from '../documents/DocumentPatent'

export default {
  components: {
    DocumentPatent,
    AffiliationTop
  },
  props: ['context', 'value', 'listType', 'nbEstimateAffiliation', 'nbAffiliations', 'changeSort'],
  name: 'ListAffiliationsResults',
  watch: {
    value: function (val) {
      this.affiliations = val
      console.log('update affiliations', val)
    }
  },
  data () {
    return {
      affiliations: null
    }
  },
  computed: {
    bestExperts: function () {
      return this.nbAffiliations
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.affiliations = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAffiliations/ListAffiliationsResults.vue